// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application.js"

import ActionJsController from "./action_js_controller.js"
application.register("action_js", ActionJsController)

import ReactController from "./react_controller.jsx"
application.register("react", ReactController)

import ActionJsSnippetController from "./action_js_snippet_controller.js"
application.register("action-js-snippet", ActionJsSnippetController)

